import { useState } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { PageContent } from '@/shared/components/PageContent';
import { DashboardHeader } from '@/features/dashboard/components/DashboardHeader';
import { DashboardSummary } from '@/features/dashboard/components/DashboardSummary/DashboardSummary';
import { DashboardMovements } from '@/features/dashboard/components/DashboardMovements/DashboardMovements';
import { useDashboardSummary } from '@/features/dashboard/hooks/useDashboard/useDashboardSummary';
import { useDashboardMovements } from '@/features/dashboard/hooks/useDashboard/useDashboardMovements';


function resolveDashboardUserFirstName(
  fromSummary: string | undefined,
  memberName: string | undefined,
  userFirstName: string | undefined,
  fullName: string | undefined
): string {
  const a = fromSummary?.trim();
  if (a) return a;
  const b = memberName?.trim();
  if (b) return b;
  const c = userFirstName?.trim();
  if (c) return c;
  const d = fullName?.trim();
  if (d) {
    const first = d.split(/\s+/)[0];
    if (first) return first;
  }
  return '';
}

export default function DashboardPage() {
  const { userData, user, member, payload: authPayload } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  
  const { summary, userSpending, userDetails, customerDetails } = useDashboardSummary(authPayload?.user_uuid || "");
  const { data: movements, total } = useDashboardMovements( 
    authPayload?.customer_uuid || "", 
    currentPage,
    userData.role,
    authPayload?.user_uuid
  );

  const headerUserName = resolveDashboardUserFirstName(
    userDetails?.name,
    member?.name,
    user?.firstName,
    userData.fullName
  );

  return (
    <PageContent
      header={
        <DashboardHeader
          userName={headerUserName}
          companyName={customerDetails?.legal_name || ''}
          companyId={customerDetails?.key_id || ''}
        />
      }
    >
      <div>
          <DashboardSummary 
            summary={summary} 
            userSpending={userSpending} 
          />
        
        <DashboardMovements 
          data={movements} 
          total={total} 
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </PageContent>
  );
}

export { DashboardPage };

